import {useContext} from "react";
import {ToastContext} from "../Contexts";
import {
    GetWebsitesResponse,
    ToastFailureMessage
} from "../Models/Models";
import HttpRepository from "./HttpRepository";

export function WebsiteService() {
    let {setToast}: any = useContext(ToastContext);

    async function getWebsites(): Promise<GetWebsitesResponse> {
        try {
            return (await HttpRepository.getWebsites()).data;
        } catch (error) {
            setToast({message: ToastFailureMessage.dataNotLoaded});
            throw Error(error);
        }
    }

    return {getWebsites}
}